import { render, staticRenderFns } from "./GetDevData.vue?vue&type=template&id=54ba970d&scoped=true&"
import script from "./GetDevData.vue?vue&type=script&lang=js&"
export * from "./GetDevData.vue?vue&type=script&lang=js&"
import style0 from "./GetDevData.vue?vue&type=style&index=0&id=54ba970d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba970d",
  null
  
)

export default component.exports